export default {"src":"/_next/static/media/twitter-icon.36ea4602.svg","height":24,"width":24};